<template>
    <custom-container-full :budget-data="budgetData">
        <div class="injerto-positioner">
            <h4 class="c-question">¿Quieres la planta injertada?</h4>
            <injerto-type-buttons v-model="injerto" style="font-size: 1.2em"></injerto-type-buttons>
            <div class="c-show-benefits">
                <b-button @click="showBenefitsVisible = !showBenefitsVisible" squared block>
                    Ver beneficios de planta injertada <i class="fas" :class="showBenefitsIcon"></i>
                </b-button>
                <b-collapse v-model="showBenefitsVisible" visible>
                    <div style="margin-top: 1rem">
                        <p>
                            En ocasiones, la variedad o la especie que queremos cultivar no es la que mejor
                            aguanta el clima o los patógenos de nuestra zona.<br>
                            Por ello, se elige un patrón que esté adaptado a estos pormenores, y en él se
                            injerta la variedad de interés.
                        </p>
                        <h6>Principales ventajas de un injerto en planta hortícola.</h6>
                        <p>
                            Mayor, vigor de crecimiento, precocidad y calibre de fruto. <br>
                            Resistencia frente  a enfermedades del suelo, como la "raíz corchosa" o
                            infecciones por Vertillium,
                            nematodos y Fusarium. <br>
                            Alternativa al uso de bromuro de metilo para desinfectar el suelo.
                        </p>
                    </div>
                </b-collapse>
            </div>
        </div>
        <template v-slot:columnExtraData>
            <btn-next :disabled-next="disabledNext" @click="goNext"></btn-next>
        </template>
    </custom-container-full>
</template>

<script>
import CustomContainerFull from "./CustomContainerFull";
import InjertoTypeButtons from "./InjertoTypeButtons";
import BtnNext from "./BtnNext";
export default {
name: "InjertoTypeSelect",
    components: {BtnNext, InjertoTypeButtons, CustomContainerFull},
    props: {
        budgetData: {
            type: [Object, null],
            default: null
        }
    },
    data() {
        return {
            injerto: null,
            showBenefitsVisible: false,
        }
    },
    computed: {
        disabledNext() {
            return this.eco === null || this.saving;
        },
        showBenefitsIcon() {
            let icon = 'fa-angle-';
            if (this.showBenefitsVisible) {
                icon += 'up';
            } else {
                icon += 'down'
            }
            return icon;
        }
    },
    watch: {
        budgetData() {
            this.setBudgetData();
        }
    },
    methods: {
        setBudgetData() {
            let injerto = null;
            if (this.budgetData) {
                injerto = !!this.budgetData.injerto_type;
            }
            this.injerto = injerto;
        },
        goNext() {
            let vm = this;
            vm.saving = true;
            let formData = new FormData();
            formData.append('injerto', vm.injerto ? 1 : 0);
            axios.post(vm.route('custom.injerto-type-select-next'), formData).then((response) => {
                window.location = vm.route('custom.index');
            }).catch(e => {
                Vue.toasted.error("Error al enviar los datos al servidor", {
                    duration: 3000
                });
            }).finally(() => {
                vm.saving = false;
            });
        }
    },
    created() {
        this.setBudgetData();
    }
}
</script>

<style scoped>

.c-question {
    font-weight: bold;
    font-size: 1.25rem;
}

.c-show-benefits {
    margin-top: 0.5em;
    margin-bottom: 1.5em;
}

.c-show-benefits > button {
    color: #008A83;
    font-weight: bold;
    background: none;
    border: 0;
}

.c-show-benefits > button:hover {
    background-color: #008A83;
    color: #ffffff;
}

.c-show-benefits h6 {
    color: #008A83;
    font-weight: bold;
}

.c-show-benefits p, .c-show-benefits h6 {
    text-align: justify;
}

.injerto-positioner {
    max-width: 400px;
    margin: auto;
    padding-top: 2rem;
}

@media (min-width: 575px) {

    .c-show-benefits {
        margin-top: 1.25em;
    }

}

@media (min-width: 992px) {
    .c-question {
        padding-bottom: 0.8em;
    }

    .injerto-positioner {
        padding-bottom: 1rem;
    }

}

</style>
